module.exports = __webpack_public_path__ + "img/earth.53ab0f03.svg";